var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#333333",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2146 4869 c-62 -15 -153 -68 -197 -116 -22 -24 -55 -74 -72 -111 l-32 -67 -3 -219 c-4 -265 0 -290 72 -361 103 -103 244 -100 339 5 57 64 67 101 67 264 l0 136 1040 0 1040 0 0 -1840 0 -1840 -1040 0 -1040 0 0 136 c0 163 -10 200 -67 264 -95 105 -236 108 -339 5 -72 -71 -76 -96 -72 -362 l3 -219 37 -76 c45 -91 103 -147 196 -191 l67 -32 1215 0 1215 0 67 32 c93 44 151 100 196 191 l37 76 0 2015 0 2016 -32 67 c-44 93 -100 151 -191 196 l-76 37 -1195 2 c-701 1 -1212 -3 -1235 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2733 3699 c-114 -21 -194 -117 -194 -234 0 -93 13 -112 299 -397 l267 -268 -1329 0 c-1014 0 -1338 -3 -1370 -12 -86 -26 -166 -136 -166 -228 0 -92 80 -202 166 -228 32 -9 356 -12 1370 -12 l1329 0 -267 -267 c-177 -177 -272 -281 -283 -305 -21 -51 -19 -144 4 -193 23 -49 74 -99 123 -119 51 -22 143 -20 193 3 27 13 199 179 531 512 521 524 514 516 514 609 0 93 7 85 -514 608 -270 271 -503 500 -519 508 -40 21 -106 31 -154 23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBlack);
export default __webpack_public_path__ + "static/media/LoginBlack.142ccb234fa935c684f5c168b5885961.svg";
export { ForwardRef as ReactComponent };